import { EmulatorType, LanguageField } from './types';

export const languages = [LanguageField.UK, LanguageField.EN];
export const emulator_types = [EmulatorType.FPV, EmulatorType.MAVIC];
